import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditMultipleSelectInput } from './edit';
import { PreviewMultipleSelectInput } from './preview';
import { ViewMultipleSelectInput } from './view';

export const MultipleSelectInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	if (renderMode === FormRenderMode.EDIT) {
		return (
			<EditMultipleSelectInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	if (renderMode === FormRenderMode.PREVIEW) {
		return (
			<PreviewMultipleSelectInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	return (
		<ViewMultipleSelectInput
			fieldId={fieldId}
			fieldInputId={fieldInputId}
			fieldLabelId={fieldLabelId}
			fieldErrorId={fieldErrorId}
		/>
	);
};
